import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { TFulfilledAction, TPendingAction, TRejectedAction } from 'types/store';
import {
  handleFulfilledMatcherCase,
  handlePendingMatcherCase,
  handleRejectedMatcherCase,
  commonInitialState,
} from 'utils';

export const namespace = 'payments/receivedPayments';

// Reducer Matcher Case
function isPendingAction(action: AnyAction): action is TPendingAction {
  return action.type.includes(namespace) && action.type.endsWith('pending');
}

function isFulfilledAction(action: AnyAction): action is TFulfilledAction {
  return action.type.includes(namespace) && action.type.endsWith('fulfilled');
}

function isRejectedAction(action: AnyAction): action is TRejectedAction {
  return action.type.includes(namespace) && action.type.endsWith('rejected');
}

const initialState: Record<string, ISliceState<any>> = {
  getRecievedGWCLPaypointsState: commonInitialState,
  getRecievedGWCLPaypointsSummaryState: commonInitialState,
  getRecievedElectronicPaymentsState: commonInitialState,
  getRecievedElectronicPaymentsSummaryState: commonInitialState,
  getRecievedThirdPartyPaypointsState: commonInitialState,
  getRecievedThirdPartyPaypointsSummaryState: commonInitialState,
};

// Slice
const receivedPaymentsApiSlice = createSlice({
  name: namespace,
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(isPendingAction, handlePendingMatcherCase)
      .addMatcher(isFulfilledAction, handleFulfilledMatcherCase)
      .addMatcher(isRejectedAction, handleRejectedMatcherCase)
      .addDefaultCase(state => state);
  },
});

export default receivedPaymentsApiSlice.reducer;
